import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Circle } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/utils';

const RadioGroup = ({
  className,
  isError,
  ...props
}: React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Root> & {
  isError?: boolean;
}) => {
  const hasError = props['aria-invalid'] === true || !!isError;

  return (
    <RadioGroupPrimitive.Root
      className={cn(
        'group grid gap-2',
        hasError && 'radio-group-error not-focus-visible:[&_button]:border-outline-error not-focus-visible:[&_button]:border-2',
        props.orientation === 'horizontal' ? 'grid-flow-col' : '',
        className,
      )}
      {...props}
    />
  );
};

const RadioGroupItem = ({
  ref,
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & { ref?: React.RefObject<React.ComponentRef<typeof RadioGroupPrimitive.Item> | null> }) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'border-outline-checkbox text-text-default-primary text-body-m-regular ring-offset-fill-background-neutral [&_svg]:fill-text-brand-primary [&_svg]:stroke-text-brand-primary hover:[&_svg]:fill-text-brand-hover hover:[&_svg]:stroke-text-brand-hover active:[&_svg]:fill-text-brand-primary active:[&_svg]:stroke-text-brand-primary aspect-square h-5 w-5 rounded-full border active:border disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className='flex items-center justify-center'>
        <Circle className='h-3 w-auto' />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
};

export { RadioGroup, RadioGroupItem };
